import { useAtom } from 'jotai'
import { addMoneySimbols } from '../../../../../../app/utils/formatMoneyValue'
import { Button } from '../../../../../components/ui/button'
import { currentStep } from '../../../../../../app/store'
import { useFormContext } from 'react-hook-form'
import { formData } from '../useNewWithdrawModal'

const createItemsArray = (data?: formData) => {
  if (!data || !data.personalInfo || !data.address || !data.bankAccount)
    return []

  const { personalInfo, address, bankAccount } = data
  const numberStr = (address.number?.toString() || '').trim() || 'S/N'
  return [
    { label: 'Nome', value: personalInfo.name },
    {
      label: 'Data de Nascimento',
      value: personalInfo.birthDate,
    },
    { label: 'RG', value: personalInfo.rg.number },
    {
      label: 'Data de Emissão do RG',
      value: personalInfo.rg.date,
    },
    { label: 'Estado do RG', value: personalInfo.rg.uf },
    { label: 'Órgão Emissor do RG', value: personalInfo.rg.org },
    { label: 'CEP', value: address.zipCode },
    { label: 'Bairro', value: address.neighborhood },
    { label: 'Cidade', value: address.city },
    { label: 'Estado', value: address.state },
    { label: 'Rua', value: address.street },
    { label: 'Número', value: numberStr },
    { label: 'Complemento', value: address.complement },
    { label: 'Tipo de Conta', value: bankAccount.accountType },
    { label: 'Banco', value: bankAccount.bank },
    { label: 'Agência', value: bankAccount.agency },
    { label: 'Conta', value: bankAccount.account },
  ]
}

interface ReviewProposalProps {
  visible?: boolean
  value?: number
  isSubmitting?: boolean
  handleOpenConfirmation?: () => void
}

export default function ReviewProposal({
  visible,
  value,
  isSubmitting,
  handleOpenConfirmation,
}: ReviewProposalProps) {
  const [, setStep] = useAtom(currentStep)
  const { getValues } = useFormContext<formData>()
  const values = getValues()
  const items = createItemsArray(values)

  return (
    <div
      className={
        visible ? 'mt-8 flex flex-col gap-8 max-sm:mt-4 max-sm:gap-4' : 'hidden'
      }
    >
      <div className="text-black01">
        <p className="text-sm font-medium">Valor proposto</p>
        <h3 className="text-3xl font-semibold">
          {addMoneySimbols(value ?? 0)}
        </h3>
      </div>
      <ul className="flex max-h-[200px] flex-col overflow-y-auto border-b max-sm:max-h-[150px]">
        {items.map(({ label, value }) => (
          <li
            className="flex items-baseline justify-between font-medium max-sm:flex-col max-sm:items-start max-sm:gap-1 max-sm:py-1"
            key={label}
          >
            <p className="text-xs text-black04">{label}</p>
            <strong className="text-sm text-black01 max-sm:text-xs">
              {value}
            </strong>
          </li>
        ))}
      </ul>
      <div className="flex justify-end gap-5 max-sm:flex-col max-sm:gap-3">
        <Button
          type="button"
          className="rounded-full bg-white02 px-8 py-3 font-semibold text-black01 hover:bg-white02 max-sm:order-2"
          onClick={() => setStep(0)}
        >
          Editar dados
        </Button>
        <Button
          type="button"
          disabled={isSubmitting}
          onClick={handleOpenConfirmation}
          className="rounded-full px-8 py-3 font-semibold text-white max-sm:order-1"
        >
          Realizar proposta
        </Button>
      </div>
    </div>
  )
}
